import { render } from "./SessionListColumn.vue?vue&type=template&id=0bd44e0d&scoped=true"
import script from "./SessionListColumn.vue?vue&type=script&lang=js"
export * from "./SessionListColumn.vue?vue&type=script&lang=js"

import "./SessionListColumn.vue?vue&type=style&index=0&id=0bd44e0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd44e0d"]])

export default __exports__